import ApplePass from "components/apple-pass";
import GooglePass from "components/google-pass";
import { useAuth } from "context/auth";
import { PASS_VIEW } from "enums";
import { ACCOUNT_TYPE } from "enums/user";
import { useFormikContext } from "formik";
import EyeIcon from "icons/eye";
import { useState, useEffect } from "react";
import Api from "utils/api";
import { enums } from "global/enums";
import { decryptJSON } from "global/security";
import Loader from "components/loader";

function PassPreview({ children, view, values }) {
  const [showPass, setShowPass] = useState(false);
  const formik = useFormikContext?.();
  const { currentUser } = useAuth();
  const [designs, setDesigns] = useState([]);
  const [designss, setDesignss] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const handleGettingDesigns = async () => {
    try {
      const { error, response } = await Api(
        `/${enums.ROLES[currentUser.role]}/getDesigns`,
        "get"
      );

      if (response) {
        const decryptedData = decryptJSON(response.data);
        const defaultDesignn = decryptedData;
        const defaultDesign =
          decryptedData.find((item) => item.default === true) || null;
        setDesignss(defaultDesignn);
        console.log(defaultDesignn);
        setDesigns(defaultDesign);
      }
    } catch (err) {
      console.error("Error in fetchDesigns:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    handleGettingDesigns();
  }, []);

  let currentDesign = {};
  const passType = view || currentUser.passType;

const normalizePreviewSocials = (socials = []) => {
  return socials
    .filter((s) => s?.value && typeof s.value === "string")
    .map((s) => {
      const cleanValue = s.value.replace(/^https::\/\//, "https://");
      const lower = cleanValue.toLowerCase();

      if (lower.includes("linkedin.com")) {
        return { type: "linkedin", value: cleanValue };
      }

      if (lower.includes("facebook.com")) {
        return { type: "facebook", value: cleanValue };
      }

      if (lower.includes("twitter.com") || lower.includes("x.com")) {
        return { type: "twitter", value: cleanValue };
      }

      // website only
      return { type: s?.type || "work", value: cleanValue };
    });
};






const splitSocialsForQR = (socials = []) => {
  const socialProfiles = [];
  const websites = [];

  socials.forEach((s) => {
    if (!s?.value) return;

    if (
      s.type === "linkedin" ||
      s.type === "facebook" ||
      s.type === "twitter"
    ) {
      socialProfiles.push(s);
    } else {
      websites.push({
  type: s.type && ["work","home","custom"].includes(s.type) ? s.type : "work",
  value: s.value,
});

    }
  });

  return {
    socials: socialProfiles,
    websites,
  };
};





  const getFullName = () => {
    let name = formik.values.firstName + " " + formik.values.lastName;
    if (formik.values.prefix) name = formik.values.prefix + " " + name;
    return name;
  };

  const getPhone = (values) => {
    if (values.phone) return values.phone;
    if (values.phones) return values.phones[0]?.value;
    return "";
  };
  console.log(currentUser);





  if (values) {
  const normalized = normalizePreviewSocials(values.socials || []);
  const { socials, websites } = splitSocialsForQR(normalized);

  currentDesign = {
    backgroundColor: values.backgroundColor,
    logoImage: values.logoImage,
    stripImage: values.stripImage,
    jobTitle: values.jobTitle,
    fullName: values.fullName,
    email: values.email,
    phone: getPhone(values),
    phones: values.phones,
    organisationName: values.organisationName,

    // ✅ ALL websites
    companyURL: websites,

    // ✅ ONLY LinkedIn
    socials: socials,

    addresses: values.addresses,
    prefix: values.prefix,
    firstName: values.firstName,
    lastName: values.lastName,
    personalAccount: currentUser.account?.type === ACCOUNT_TYPE.PERSONAL,
  };
}


else if (formik?.values) {
  const normalized = normalizePreviewSocials(formik.values.socials || []);
  const { socials, websites } = splitSocialsForQR(normalized);

  currentDesign = {
    backgroundColor: formik.values.backgroundColor,
    logoImage: formik.values.logoImage,
    stripImage: formik.values.stripImage,
    jobTitle: formik.values.jobTitle,
    fullName: getFullName(),
    email: formik.values.email,
    phone: getPhone(formik.values),
    phones: formik.values.phones,
    organisationName: formik.values.organisationName,

    companyURL: websites,
    socials: socials,

    addresses: formik.values.addresses,
    prefix: formik.values.prefix,
    firstName: formik.values.firstName,
    lastName: formik.values.lastName,
    personalAccount: currentUser.account?.type === ACCOUNT_TYPE.PERSONAL,
  };
}


else {
  const normalized = normalizePreviewSocials(currentUser.socials || []);
  const { socials, websites } = splitSocialsForQR(normalized);

  currentDesign = {
    backgroundColor:
      designs?.backgroundColor ||
      currentUser?.design?.backgroundColor ||
      "#fff",

    logoImage: designs?.logoImage || currentUser?.design?.logoImage,
    stripImage: designs?.stripImage || currentUser?.design?.stripImage,
    jobTitle: currentUser.jobTitle,
    fullName: `${currentUser.firstName} ${currentUser.lastName}`,
    email: currentUser.email,
    phone:
      currentUser.dialCode + currentUser.phone ||
      currentUser.phones[0]?.dialCode + currentUser.phones[0]?.value,

    phones: currentUser.phones,
    organisationName: currentUser.account?.organizationName,

    companyURL: websites,
    socials: socials,

    addresses: currentUser.addresses,
    prefix: currentUser.prefix,
    firstName: currentUser.firstName,
    lastName: currentUser.lastName,
    personalAccount: currentUser.account?.type === ACCOUNT_TYPE.PERSONAL,
  };
}



  console.log("🟣 PREVIEW SOCIALS =", currentDesign.socials);
  console.log("🌐 PREVIEW URL =", currentDesign.companyURL);



  return isLoading ? (
    <Loader />
  ) : (
    <div style={{ width: "330px" }}>
      <div
        onClick={() => setShowPass(!showPass)}
        className="tw-flex tw-mb-2 md:tw-hidden tw-justify-center"
      >
        <div className="tw-border tw-border-black tw-py-[8px] tw-px-[20px] tw-rounded-[4px] tw-flex tw-items-center tw-gap-[7px] tw-cursor-pointer tw-text-[15px]">
          <EyeIcon />
          View card
        </div>
      </div>
      <div className={showPass ? "tw-block" : "tw-hidden md:tw-block"}>
        {passType == PASS_VIEW.APPLE ? (
          <>
            <ApplePass design={currentDesign} values={values} />
          </>
        ) : (
          <>
            <GooglePass design={currentDesign} values={values} />
          </>
        )}
        {children}
      </div>
    </div>
  );
}



export default PassPreview;
